import React from "react";
import { useLocation } from "react-router-dom";
import NavLink from "./navlink";
import "./footer.css";

const footer_links = [
  { sectionId: "home", linkText: "Home", to: "/" },
  { sectionId: "portraits", linkText: "Portraits", to: "/#portraits" },
  { sectionId: "collage", linkText: "Collage", to: "/#collage" },
  { sectionId: "timeline", linkText: "Timeline", to: "/#timeline" }
];

const Footer = () => {
  const location = useLocation();

  const createSectionHandler = (sectionId) => (event) => {
    const isHomeRoute = location.pathname === "/";
    const nextHash = sectionId === "home" ? "" : `#${sectionId}`;
    const currentHash = location.hash || "";

    if (!isHomeRoute) {
      return;
    }

    if (sectionId === "home") {
      event.preventDefault();
      window.history.replaceState({}, "", "/");
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    if (currentHash === nextHash) {
      event.preventDefault();
      const target = document.getElementById(sectionId);

      if (target) {
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  };

  return (
    <footer className="site_footer">
      <div className="site_footer_inner">
        <div className="site_footer_intro">
          <p className="site_footer_eyebrow">A House of Possibility</p>
          <NavLink
            className="is_brand site_footer_brand"
            linkText="Emily Dickinson"
            onClick={createSectionHandler("home")}
            to="/"
          />
          <p className="site_footer_text">
            Portraits, letters, and inward weather gathered into one theatrical room.
          </p>
        </div>

        <div className="site_footer_links_block">
          <p className="site_footer_label">Explore</p>
          <nav className="site_footer_nav" aria-label="Footer">
            {footer_links.map((item) => (
              <NavLink
                key={item.sectionId}
                className="site_footer_link"
                linkText={item.linkText}
                onClick={createSectionHandler(item.sectionId)}
                to={item.to}
              />
            ))}
          </nav>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
